import Vue from 'vue'

import CrmAddressFields from './CrmAddressFields'

Vue.component('CrmAddressFields', CrmAddressFields)
